import React from 'react';
import PropTypes from 'prop-types';

import * as Styles from './OverlayBox.styles';

export const OverlayBox = ({ children, isDragActive, text, uploadContainerProps }) => (
  <div
    className={Styles.wrapper}
    {...uploadContainerProps}
  >
    {isDragActive && (
      <div className={Styles.overlay}>
        <em>{text}</em>
      </div>
    )}
    {children}
  </div>
);

OverlayBox.propTypes = {
  children: PropTypes.node.isRequired,
  isDragActive: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired,
  uploadContainerProps: PropTypes.object.isRequired,
};

export default OverlayBox;
